// src/store/index.js
import { createStore } from "vuex";

export default createStore({
	state: {
		jwt: localStorage.getItem("managerToken") || null, // Initialize the state from localStorage
		isMenuExpanded: false, // État pour gérer l'affichage du menu
	},
	mutations: {
		// Gestion du JWT
		setJwt(state, token) {
			state.jwt = token;
		},
		clearJwt(state) {
			state.jwt = null;
		},

		// Gestion du menu
		toggleMenu(state) {
			state.isMenuExpanded = !state.isMenuExpanded;

			if (state.isMenuExpanded) {
        document.documentElement.setAttribute(
          "class",
          "light-style layout-navbar-fixed layout-compact layout-menu-100vh layout-menu-fixed layout-menu-expanded"
        );
      } else {
        document.documentElement.setAttribute(
          "class",
          "light-style layout-navbar-fixed layout-compact layout-menu-100vh layout-menu-fixed"
        );
      }
		},
	},
	actions: {
		// Gestion du JWT
		saveJwt({ commit }, token) {
			localStorage.setItem("managerToken", token); // Save token to localStorage
			commit("setJwt", token); // Save token to Vuex state
		},
		logout({ commit }) {
			localStorage.removeItem("managerToken"); // Remove token from localStorage
			commit("clearJwt"); // Clear Vuex state
		},

		// Gestion du menu
		toggleMenu({ commit }) {
			commit("toggleMenu");
		},
	},
	getters: {
		isLoggedIn: (state) => !!state.jwt, // Vérifie si un utilisateur est connecté
		isMenuExpanded: (state) => state.isMenuExpanded, // Retourne l'état du menu
	},
});
